import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import BuyerLayout from "../components/Layout";
import NewNotificationsTable from "../components/Tables/Table/NewNotificationsTable";
import PreviousNotificationsTable from "../components/Tables/Table/PreviousNotificationsTable";

const styles = {
    sectionSpacing: {
        marginTop: 50,
    },
};

const Notifications = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Obaveštenja" },
    ];

    return (
        <BuyerLayout>
            <Breadcrumb title={"Obaveštenja"} breadcrumbs={breadcrumbs} />

            <div style={styles.sectionSpacing}>
                <NewNotificationsTable />
            </div>

            <div style={styles.sectionSpacing}>
                <PreviousNotificationsTable />
            </div>
        </BuyerLayout>
    );
};

export default Notifications;
